
const noProductButtons = document.querySelectorAll('.no-product');

const modalInner = document.querySelector('.modal-inner');
const modalOuter = document.querySelector('.modal-outer');


if (noProductButtons) {

function handleButtonClick(event) {

  const button = event.currentTarget;
  const productSize = button.getAttribute('data-size');
  const productImage = button.getAttribute('data-image');
  const productId = button.getAttribute('data-product-id');
  const productVariationId = button.getAttribute('data-variation-id');


  fetch('/wp-admin/admin-ajax.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      action: 'load_product_modal',
      size: productSize,
      image: productImage,
      product_id: productId,
      variation_id: productVariationId,
    })
  })
  .then(response => response.json())
  .then(data => {

    if (data.success) {
      modalInner.innerHTML = data.data;
      modalOuter.classList.add('open');

      const modalCloseButton = document.querySelector('.modal-close');
      modalCloseButton.addEventListener('click',closeModal);

    }
  })
  .catch(error => console.error('Error:', error));


}

function closeModal() {
  modalOuter.classList.remove('open');
}

noProductButtons.forEach((noProductButton) => {
  noProductButton.addEventListener('click', handleButtonClick);
});

if (modalOuter) {
  modalOuter.addEventListener('click', (event) => {
    const isOutside = !event.target.closest('.modal-inner');
    if (isOutside) {
      closeModal();
    }
  });
}

}